import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { PageContent } from 'components/enrollment/add-employees/full-employee-form';
import { useFullEmployeeFormUrlParams } from 'global/hooks/useEmployeeFullFormUrlParams';
import FullFormPageStore, { FullFormPageStoreContext } from 'store/pages/enrollment/add-employees/full-form/pageStore';

/** TESTING_POLICY: CYPRESS_ONLY */

const FullFormPage: React.FC = observer(() => {
  const { periodId, groupId, subscriberId, activeTabId } = useFullEmployeeFormUrlParams();

  // Same as quote full form: subscriberId/activeTabId must not recreate the store when cleared
  // from the URL (Add Another Employee), or the page remounts and getInitialData races the reset.
  const store = useMemo(
    () => new FullFormPageStore({ groupId, periodId, subscriberId, activeTabId }),
    [groupId, periodId],
  );

  return (
    <FullFormPageStoreContext.Provider value={store}>
      <PageContent />
    </FullFormPageStoreContext.Provider>
  );
});

export default FullFormPage;
